/**
 * Amnil brand palette (onboarding-demo branch).
 *
 * The styled-components theme normally comes 1:1 from the backend's
 * "Theme settings" group (see useTheme). On this branch the colour keys are
 * pinned to the Amnil palette instead, so every globalStyles.ts rule that reads
 * them -- nav tabs, .btn-primary/.btn-secondary, .dt-btn-*, rsuite inputs and
 * pickers, links, table headers -- follows the same look as /auth/login,
 * /dashboard and /profile. Non-colour settings (logo, favicon, ...) still come
 * from the backend untouched.
 *
 * Sidebar/header keys are deliberately NOT overridden: the aside keeps
 * whatever the backend configures.
 */
export const AMNIL_COLORS = {
  navy: '#30305E',
  navyDark: '#1B1B3A',
  crimson: '#EE1A49',
  crimsonDark: '#C8123B',
  orange: '#FF5122',
}

export const AMNIL_THEME_OVERRIDES = {
  primaryColor: AMNIL_COLORS.navy,
  linkColor: AMNIL_COLORS.crimson,
  btnPrimaryColor: AMNIL_COLORS.crimson,
  btnPrimaryTextColor: '#FFFFFF',
  btnSecondaryBgcolor: AMNIL_COLORS.navy,
  btnSecondaryTextColor: '#FFFFFF',
}

export const withAmnilPalette = <T extends Record<string, any>>(theme: T): T => ({
  ...theme,
  ...AMNIL_THEME_OVERRIDES,
})
